import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { API_URL } from '../../constants';
import { FormGenerator } from '../../helper/FormGenerator';
import { useTokens } from '../../context/TokenContext';

const EditProfile = ({ id, data, onUpdate }) => {
    const { getItem } = useTokens();
    const adminAuthToken = getItem('admin', 'AuthToken');
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        ...data?.basic || {},
        ...data?.meta || {}
    });

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const toastId = toast.loading('Saving your settings...', { autoClose: false });

        try {
            const dataToSend = {
                basic: {
                    first_name: formData.first_name,
                    last_name: formData.last_name,
                    phone: formData.phone,
                    email: formData.email,
                    status: formData.status,
                    roles: formData.roles,
                    profile_picture: formData.profile_picture,
                },
                meta: {
                    gender: formData.gender,
                    gst: formData.gst,
                    dob: formData.dob,
                }
            };

            const response = await axios.put(`${API_URL}/admin/user/${id}`, dataToSend, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${adminAuthToken}`,
                },
            });

            if (response.status === 200) {
                toast.update(toastId, {
                    render: 'Settings saved successfully!',
                    type: 'success',
                    isLoading: false,
                    autoClose: 3000,
                });
                if (onUpdate) onUpdate();
            }
        } catch (error) {
            toast.update(toastId, {
                render: 'Failed to save settings. Please try again.',
                type: 'error',
                isLoading: false,
                autoClose: 3000,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <h2>Profile</h2>
            <p>Update your profile information below.</p>

            <form onSubmit={handleFormSubmit}>
                <div className='row'>
                    <FormGenerator
                        fields={[
                            { id: "status", label: "User Status", type: "select", options: { 1: "Active", 0: "Inactive" }, class: 'col-md-6' },
                            { id: "roles", label: "Role", type: "select", options: { 'ROLE_VENDOR': 'Vendor', 'ROLE_CUSTOMER': 'Customer' }, class: 'col-md-6', required: true },
                            { id: 'first_name', label: 'First Name', type: 'text', class: 'col-md-6', required: true },
                            { id: 'last_name', label: 'Last Name', type: 'text', class: 'col-md-6', required: true },
                            { id: 'phone', label: 'Phone Number', type: 'tel', class: 'col-md-6', required: true, prefix: '+91', minLength: 10, maxLength: 10, isNumeric: true },
                            { id: 'email', label: 'Email', type: 'email', class: 'col-md-6', required: true },
                            { id: 'gst', label: 'GST', type: 'text', class: 'col-md-6', required: false, isAlphaNumeric: true, minLength: 15, maxLength: 15 },
                            { id: 'dob', label: 'Date of Birth', type: 'date', class: 'col-md-6' },
                            { id: 'profile_picture', label: 'Profile Picture', type: "upload_single", class: 'col-md-6' },
                            { id: "gender", label: "Gender", type: "radio", options: ["male", "female", "other"], required: true, class: 'col-md-6' }
                        ]}
                        fieldData={formData}
                        onChange={(field, value) => setFormData((prev) => ({ ...prev, [field]: value }))}
                        hTure={false}
                        authToken={adminAuthToken}
                    />
                </div>

                <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? 'Saving...' : 'Save Settings'}
                </button>
            </form>
        </div>
    );
};

export default EditProfile;
